import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

const VisitLogModal = ({ open, onOpenChange, campaignId, campaigns, visits }) => {
  const campaign = campaigns.find(c => c.id === campaignId);
  const logs = visits.filter(v => v.pageId === campaignId);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-auto">
        <DialogHeader>
          <DialogTitle>📋 {campaign?.name} — история визитов</DialogTitle>
        </DialogHeader>
        {logs.length === 0 ? (
          <p className="text-center py-4 text-slate-400">Нет переходов по QR-коду</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>IP</TableHead>
                <TableHead>Аватар</TableHead>
                <TableHead>ФИО</TableHead>
                <TableHead>Телефон</TableHead>
                <TableHead>Канал</TableHead>
                <TableHead>Дата</TableHead>
                <TableHead>Время</TableHead>
                <TableHead>Цель</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {logs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell>{log.ip}</TableCell>
                  <TableCell>
                    <img src={log.avatar} alt="avatar" className="w-6 h-6 rounded-full" />
                  </TableCell>
                  <TableCell>{log.fullName}</TableCell>
                  <TableCell>{log.phone}</TableCell>
                  <TableCell>{log.sourceType || '—'}</TableCell>
                  <TableCell>{log.date}</TableCell>
                  <TableCell>{log.time}</TableCell>
                  <TableCell>
                    {log.targetReached ? '✅ Регистрация' : '⏳ Не выполнено'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VisitLogModal;